<template>
   <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid">
            <!-- sign up page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-sm-12 p-0">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="card p-3">
                                    <h4 class="text-center">{{ $t('register.newUserHost') }}</h4>
                                    <h6 class="text-center text-info ">{{ $t('register.nameAndPassword') }}</h6>
                                    <form class="theme-form">
                                        <div class="form-group">
                                            <label for="name" class="col-form-label text-primary f-w-600">{{ $t('register.name') }}</label>
                                            <input class="form-control" id="name" v-model="name" type="text" :placeholder="$t('register.namePh')">
                                        </div>
                                        <div class="form-group">
                                            <label for="phone" class="col-form-label text-primary f-w-600">{{ $t('register.phone') }}</label>
                                            <input class="form-control" id="phone" v-model="phone" type="text" :placeholder="$t('register.phonePh')">
                                        </div>
                                        <div class="form-group">
                                            <label for="email" class="col-form-label text-primary f-w-600">{{ $t('register.email') }}</label>
                                            <input class="form-control" id="email" v-model="email" type="email" :placeholder="$t('register.emailPh')">
                                        </div>
                                        <div class="form-group">
                                            <label for="password" class="col-form-label text-primary f-w-600">{{ $t('register.password') }}</label>
                                            <input autocomplete="" class="form-control" id="password" v-model="password" type="password" :placeholder="$t('register.passwordPh')">
                                        </div>
                                        <div class="form-group">
                                            <div class="form-row">
                                                <div class="col-sm-6">
                                                    <label for="userCat" class="col-form-label text-primary pt-0 f-w-600">{{ $t('register.userCat') }}</label>
                                                    <b-form-select v-model="userCat" class="mb-3">
                                                        <b-form-select-option value="member">{{ $t('register.member') }}</b-form-select-option>
                                                        <b-form-select-option value="admin" >{{ $t('register.admin') }}</b-form-select-option>                                                        
                                                        <b-form-select-option value="host">{{ $t('register.host') }}</b-form-select-option>
                                                    </b-form-select>
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-row">
                                            <div class="col-sm-4">
                                                <button @click="createUser" class="btn btn-primary" type="button">{{ $t('register.createUser') }}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- sign up page ends-->
        </div>
    </div>
    <!-- page-wrapper Ends-->
</template>

<script>
import { createUserWithEmailAndPassword } from 'firebase/auth'
import {authUser,createNewUserWallet ,saveWithId} from "../../firebase"
import {getRandomInt} from "../../utilities/util"
export default {
    name: 'createUserHost',
    data() {
        return{
            userId: '',
            name : '',
            phone: '',
            userCat : '',
            email: '',
            password: '',
        }
    },
    mounted(){
    },
    methods: {
        createUser() {
            let msg = 'completed'
            const phoneRegex = /^\+?1?\s*\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/
            const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g  
            if (this.name === ''){
                msg = this.$t("register.nameMsg")
            } else if (this.phone ===''){
                msg = this.$t("register.phoneMsg")
            } else if (!phoneRegex.test(this.phone)){
                msg = this.$t("register.phoneFormatMsg")                
            } else if (this.email ===''){
                msg = this.$t("register.emailMsg")
            } else if (!emailRegex.test(this.email)){
                msg = this.$t("register.emailFormatMsg")
            } else if (this.password ===''){
                msg =this.$t("register.passwordMsg")
            } else if (this.password.length < 8){
                msg = this.$t("register.passwordDigitMsg")
            } else if (this.userCat===''){
                msg = this.$t("register.userCatMsg")
            }  
            if (msg === 'completed'){
                createUserWithEmailAndPassword(authUser, this.email, this.password)
                .then( async(userCredential) => {
                    if (userCredential) {
                        let userId = `${getRandomInt(1000000 , 9000000)}`
                        let payload = {
                            uid: userCredential.user.uid,
                            userId : userId,
                            name: this.name,
                            phone:this.phone,
                            userCat: this.userCat,  
                            email: this.email,                                                      
                            ftName: this.name, 
                            dayBD: '',
                            monthBD: '',
                            yearBD: '',
                            timeBD: '',
                            estTime: '',
                            placeBD: '',                            
                            lrs: '',
                            
                        }
                        await saveWithId('Users', userId, payload).then(()=>{
                            this.$toasted.show(this.$t("register.successRegister") + this.email, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});    
                        })
                        await createNewUserWallet( 1 , userId)
                    }
                })
                .catch((error) => {
                    this.$toasted.show('Error...' + error.message, {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 5000});
                });                                              
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
    }
}
</script>
